import React from "react";
import { Link } from "react-router-dom";
import "./Pages.css";

function FAQ() {
  return (
    <article className="page-content">
      <h1>Frequently Asked Questions</h1>

      <h2>How do I calculate out-of-county mileage?</h2>
      <p>
        Go to the <Link to="/calculator">Calculator</Link> page, enter your trip&apos;s start address and end address (or use the location button to use your current position for start or end), then click &quot;Calculate Out of County Miles.&quot; CountyLee will show total mileage, starting and ending counties, and the number of miles driven outside your starting county.
      </p>

      <h2>What is the difference between total mileage and out-of-county mileage?</h2>
      <p>
        <strong>Total mileage</strong> is the full driving distance from your start address to your end address. <strong>Out-of-county mileage</strong> is the portion of that trip that falls outside the county where you started. Many employers and contracts reimburse only out-of-county miles, so knowing both numbers helps you keep accurate records and verify pay or expenses.
      </p>

      <h2>How can I track mileage for multiple trips?</h2>
      <p>
        Run the calculator once for each trip. Enter the start and end address for that trip, then record the out-of-county miles (and total miles if needed) in your own log or spreadsheet. For multiple trips in a day or week, repeat the process for each leg and add the out-of-county miles together for your total.
      </p>

      <h2>What are best practices for record-keeping for reimbursement or taxes?</h2>
      <p>
        Keep a log with the date of each trip, start and end locations, total miles, and out-of-county miles. Save the results from CountyLee (e.g., screenshot or written note) and store them with your other trip records. Confirm with your employer or accountant what they require—some want dates and addresses; others want a simple mileage total. This tool is for record-keeping only; it does not provide tax or legal advice.
      </p>

      <h2>Does CountyLee work on mobile and desktop?</h2>
      <p>
        Yes. The site is responsive and works on phones and tablets as well as desktop. You can use the location button on mobile to quickly set your current location as the start or end address. For the best experience, use a stable internet connection so the map and address lookup load correctly.
      </p>

      <h2>Who is CountyLee for?</h2>
      <p>
        CountyLee is designed for private ambulance and EMS personnel, truck drivers, independent contractors, and anyone else who needs to document out-of-county miles for reimbursement, payroll, or accounting. If your pay or reimbursement depends on out-of-county travel, this tool can help you track it accurately.
      </p>

      <p>
        More questions? <Link to="/contact">Contact us</Link>.
      </p>
    </article>
  );
}

export default FAQ;
